import React from 'react';
import PropTypes from 'prop-types';

import styles from './backButton.module.scss';
import { FaChevronLeft } from 'react-icons/fa';

const BackButton = props => {
  const { content } = props;
  return (
    <div className={styles.button} onClick={() => window.history.back()}>
      <FaChevronLeft className={styles.chevron} /> {content}
    </div>
  );
};

BackButton.propTypes = {
  content: PropTypes.string.isRequired,
  expand: PropTypes.number,
  position: PropTypes.string,
};

export default BackButton;
